export default __webpack_public_path__ + "static/media/edit-profile.771e8005.png";